import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-lessons',
  templateUrl: './add-lessons.component.html',
  styleUrls: ['./add-lessons.component.scss']
})
export class AddLessonsComponent implements OnInit {
formData: any = {
  fiqh_topic_id: '',
  title: '',
  content: ''
};
   public arrCoupons: any[] = [];
  public lang : any

    public currentLang : string
errors: any = {}; // store validation errors
topics: any[] = [];

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private language : LanguageService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')
   this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});
this.getLevels();


                  this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  this.formData.image = file.name; // send only file name ✔
}


    cancel(): void {
      this.router.navigate(['/lessons']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }

getLevels() {
  this.apisService.fiqh().subscribe({
    next: (response: any) => {
      this.topics = response.data.items || [];
      console.log('topics', this.topics);
    },
    error: (err) => {
      console.log('error in fetching', err);
    }
  });
}
    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

 const payload = {
    // question: this.formData.question,
  fiqh_topic_id: this.formData.fiqh_topic_id,
    title: this.formData.title,
    content: this.formData.content
  };

  this.apisService.addfiqhLessons(payload).subscribe({
   next: () => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تمت الإضافة بنجاح'
      : 'Added successfully'
  );

  this.router.navigate(['/lessons']);
},

error: () => {
  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ أثناء الإضافة'
      : 'Error adding'
  );
}

  });
}


}